import PerfectScrollbar from "perfect-scrollbar";

document.addEventListener("DOMContentLoaded", function () {
  Array.prototype.forEach.call(document.querySelectorAll(".js-ps-scroll"), (node) => {
    new PerfectScrollbar(node);
  });
});
